import React from "react";
import { LegalLayout } from "../components/LegalLayout";
import { NextSteps } from "../components/NextSteps";

const Privacy = () => (
  <LegalLayout overline="Legal" title="Privacy Policy" lastUpdated="December 2025">
    <h2>Who we are</h2>
    <p>
      Lawfields Solicitors (&ldquo;we&rdquo;, &ldquo;us&rdquo;, &ldquo;our&rdquo;) is a firm of
      solicitors authorised and regulated by the Solicitors Regulation Authority (SRA No. 316284).
      Our registered office is 47 North Road, Southall, Middlesex UB1 2JL.
    </p>
    <p>
      We are the data controller for the personal information we hold about you. We are registered
      with the Information Commissioner&apos;s Office.
    </p>

    <h2>Information we collect</h2>
    <ul>
      <li>Identity data (name, date of birth, identity document copies where required by law)</li>
      <li>Contact data (email address, postal address, telephone number)</li>
      <li>Matter data (details of your legal enquiry / instructions)</li>
      <li>Technical data (IP address, browser type) when you visit our website</li>
    </ul>

    <h2>How we use your information</h2>
    <p>We process your personal data to:</p>
    <ul>
      <li>Provide legal advice and conduct your matter</li>
      <li>Comply with anti-money laundering and know-your-client obligations</li>
      <li>Respond to enquiries submitted via our website contact form</li>
      <li>Meet our regulatory, accounting and tax obligations</li>
    </ul>

    <h2>Lawful basis</h2>
    <p>
      We rely on (a) the performance of a contract with you, (b) compliance with legal obligations,
      and (c) our legitimate interests in running a regulated legal practice.
    </p>

    <h2>How long we keep your information</h2>
    <p>
      We retain client files for at least 6 years from the conclusion of your matter (longer for
      certain transactions such as wills, conveyancing and child-related work), in line with SRA
      guidance and our professional indemnity insurer&apos;s requirements.
    </p>

    <h2>Sharing your information</h2>
    <p>
      We never sell your personal data. We may share information with barristers, experts, courts,
      HM Land Registry, HM Revenue &amp; Customs, regulators, and our IT &amp; case management
      providers — only where necessary for your matter or required by law.
    </p>

    <h2>Your rights</h2>
    <p>You have the right to:</p>
    <ul>
      <li>Access the personal data we hold about you</li>
      <li>Request correction of inaccurate data</li>
      <li>Request erasure where we no longer need it</li>
      <li>Object to or restrict our processing</li>
      <li>Lodge a complaint with the ICO at ico.org.uk</li>
    </ul>

    <h2>Cookies</h2>
    <p>
      We use only strictly necessary cookies to operate the website (e.g. remembering your cookie
      preference). We do not use third-party advertising or tracking cookies.
    </p>

    <h2>Contact</h2>
    <p>
      To exercise any of your rights or for privacy questions, email
      <a href="mailto:info@lawfields.co.uk"> info@lawfields.co.uk</a> or write to the registered
      office above.
    </p>

    <NextSteps
      title="What happens when you exercise your rights"
      steps={[
        {
          when: "Within 3 working days",
          title: "We acknowledge your request",
          body: "You receive written acknowledgement and a reference number. We may ask for proof of identity if it is not already on file.",
        },
        {
          when: "Within 1 calendar month",
          title: "We respond in full",
          body: "We provide the data, correction, erasure or restriction you requested — or explain in writing why we cannot (for example, where we must retain a file for SRA / AML purposes).",
        },
        {
          when: "If you are unhappy",
          title: "Escalate to the ICO",
          body: "You may complain to the Information Commissioner's Office at ico.org.uk at any time. We will cooperate fully with any investigation.",
        },
      ]}
    />
  </LegalLayout>
);

export default Privacy;
